import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import "../Styles/cardSkill.css";

export const CardSkill = ({ name, icon, desc, descEng }) => {
	const [isFlipped, setIsFlipped] = useState(false);
	const handleClick = () => setIsFlipped(!isFlipped);

	const { i18n } = useTranslation();
	const currentLanguage = i18n.language;
	const [direction, setDirection] = useState("");

	const handleMouseMove = (e) => {
		const currentX = e.clientX;
		const previousX = parseInt(e.target.dataset.x, 10);

		if (currentX > previousX) {
			setDirection("right");
		} else if (currentX < previousX) {
			setDirection("left");
		} else {
			setDirection("");
		}

		e.target.dataset.x = currentX;
	};

	return (
		<>
			<div
				onMouseMove={handleMouseMove}
				className={`cardSkill ${isFlipped ? "flipped" : ""}`}
				onClick={handleClick}
			>
				<div className="front">
					<div className="bg-gray-200 hover:bg-white gray-scale p-4  rounded-2xl cursor-pointer">
						<p className=" text-center text-gray-800 font-Poppins font-bold text-2xl">
							{name}
						</p>
						<br />
						<img
							loading="lazy"
							src={icon}
							alt={name}
							className={`w-20 h-20 mx-auto
                                        ${direction === "right" ? "rotate-right" : "rotate-left"}
                                    `}
						/>
						<br />
					</div>
				</div>
				<div className="back bg-white text-center justify-center items-center flex rounded-2xl cursor-pointer">
					<div className="flex p-4 text-justify justify-center items-center">
						<p className="text-smt font-Montserrat font-semibold">{
							currentLanguage === "es" ? desc : descEng
						}</p>
					</div>
				</div>
			</div>
		</>
	);
};
